<div *ngIf="files.length > 0" class="files-list">
  <ng-container *ngFor="let file of files; index as i">
    <glxy-uploader-file
      *ngIf="fileDeleted.observers.length > 0; else noObservers"
      [status]="file.status"
      [name]="file.name"
      [url]="file.url"
      (deleted)="deleteFile(file)"
    ></glxy-uploader-file>

    <ng-template #noObservers>
      <glxy-uploader-file [status]="file.status" [name]="file.name" [url]="file.url"></glxy-uploader-file>
    </ng-template>
  </ng-container>
</div>
